var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.device.state && _vm.reachable)?_c('v-btn',{attrs:{"text":"","color":"secondary","href":_vm.deviceURL,"target":"_blank"}},[_c('v-icon',[_vm._v("input")]),_vm._v("Manage Device")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }